import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/cancelaciones',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteCancelacionesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Cancelaciones</PageTitle>
      <View />
    </>
  );
};

export { ReporteCancelacionesPage };
